import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import { DatatableComponent } from './datatable.component';
import { ColumnComponent } from './column.component';
import { DatatableToggleColumnComponent } from './datatable-toggle-column.component';

@NgModule({
    imports: [
        CommonModule,
        MatButtonModule,
        MatCheckboxModule,
        MatDialogModule,
        MatIconModule,
        MatInputModule,
        MatMenuModule,
        MatPaginatorModule,
        MatSortModule,
        MatTableModule,
        MatProgressSpinnerModule,
        InfiniteScrollModule,
    ],
    declarations: [
        DatatableComponent,
        DatatableToggleColumnComponent,
        ColumnComponent,
    ],
    exports: [
        DatatableComponent,
        DatatableToggleColumnComponent,
        ColumnComponent,
    ]
})
export class DatatableModule {}
